exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ntextarea.form-control[data-v-51acf848]{\r\n  width:325px ;\n}\r\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/components/VTextAreaRuleInput.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"VTextAreaRuleInput.vue","sourcesContent":["\ntextarea.form-control[data-v-51acf848]{\r\n  width:325px ;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51acf848","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VTextAreaRuleInput.vue
// module id = gy4S
// module chunks = 1